import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=b6cefbc6&"
import script from "./Tickets.vue?vue&type=script&lang=js&"
export * from "./Tickets.vue?vue&type=script&lang=js&"
import style0 from "./Tickets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6cefbc6')) {
      api.createRecord('b6cefbc6', component.options)
    } else {
      api.reload('b6cefbc6', component.options)
    }
    module.hot.accept("./Tickets.vue?vue&type=template&id=b6cefbc6&", function () {
      api.rerender('b6cefbc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tickets.vue"
export default component.exports